import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../Contexts/LoginContext';
import { transformProduct } from '../../../data/constants';
import { savedBuyerPoint, getBrowserLocation } from '../../../utils/buyerLocation';
import ProductCard from '../ProductCard';
import ScrollableRow from '../../utils/ScrollableRow';

const NearbyPostings = () => {
    const { user, isLogin } = useContext(LoginContext);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buyerPoint, setBuyerPoint] = useState(null);

    useEffect(() => {
        const saved = savedBuyerPoint(user);
        if (saved) {
            setBuyerPoint(saved);
            return;
        }
        getBrowserLocation().then((point) => point && setBuyerPoint(point));
    }, [user]);

    useEffect(() => {
        if (!isLogin) return;
        const params = new URLSearchParams({ scope: 'local', sort: 'closest' });
        const buyerCountry = user?.buyerAddress?.country?.name;
        if (buyerCountry) params.set('buyerCountry', buyerCountry);
        if (buyerPoint) {
            params.set('lat', buyerPoint.lat);
            params.set('lon', buyerPoint.lon);
        }

        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/filtered?${params.toString()}`)
            .then((res) => res.data.success && setProducts(res.data.products.slice(0, 8).map(transformProduct)))
            .catch((err) => console.error('Error fetching nearby products:', err))
            .finally(() => setLoading(false));
    }, [isLogin, user?.buyerAddress?.country?.name, buyerPoint]);

    if (!isLogin || (!loading && products.length === 0)) return null;

    return (
        <section className="mainSection nearbyPostingsSection">
            <ScrollableRow
                title="Postings Near You"
                items={products}
                itemsPerRow={4}
                isLoading={loading}
                noItemsMessage="No postings available yet."
                renderItem={(product, index) => (
                    <ProductCard key={product.id || index} product={product} />
                )}
            />
        </section>
    );
};

export default NearbyPostings;
